import React from "react"
import { Table, TableProps } from "antd"
import useStickyTable, { asliLayout } from "./useStickyTable"

/**
 * tog'a #4153 (+++ #4181): oddiy antd Table — ustun sarlavhasi va «Итого» qatori joyida qotadi, qatorlar ular orasida aylanadi
 * (sahifada — ilova sarlavhasi ostida, drawer/modal ichida — uning tepasida). O'z ichki aylanish qutisi (scroll.y) bor jadvalda
 * sarlavha allaqachon qotgan — o'zgarmaydi. Bo'sh (yoki yuklanayotgan) jadvalda qotish yo'q — eskidek ko'rinadi.
 * Sahifaning `summary` si (Table.Summary.Row yoki Table.Summary) ekran pastiga yopishadi.
 */
export default function StickyTable<T extends object = any>(props: TableProps<T>) {
  const sx = props.scroll as any
  const stick = useStickyTable(!sx?.y && (props.dataSource?.length ?? 0) > 0)
  const { summary, footer, ...rest } = props
  // tog'a #4695/#4703: «hamma jadval» — jamini `footer` bilan chizgan jadvallar (formalar, oynalar) ham: summary yo'q bo'lsa footer
  // ekran pastiga yopishgan bitta keng «Итого» qatoriga aylanadi. Ustunlar soni noma'lum (children Column) bo'lsa — footer o'zgarmaydi.
  const ustunlar = Array.isArray(props.columns) ? props.columns.length + (props.rowSelection ? 1 : 0) + ((props.expandable as any)?.expandedRowRender ? 1 : 0) : 0
  const footerJami = !summary && footer && stick.sticky && ustunlar > 0
  const qotganJami = footerJami
    ? (d: readonly T[]) => (
        <Table.Summary fixed="bottom">
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={ustunlar}>{footer!(d as T[])}</Table.Summary.Cell>
          </Table.Summary.Row>
        </Table.Summary>
      )
    : summary && stick.sticky
    ? (d: readonly T[]) => { const n = summary(d); return n ? <Table.Summary fixed="bottom">{n}</Table.Summary> : n }
    : summary
  const layout = props.tableLayout ?? (stick.sticky ? asliLayout(props.columns as any[], sx?.x, !!(props.rowSelection as any)?.fixed || !!(props.expandable as any)?.fixed) : undefined)
  return <Table<T> {...rest} footer={footerJami ? undefined : footer} ref={stick.ref} sticky={stick.sticky} tableLayout={layout} summary={qotganJami} />
}
